<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-grid">
        <!-- Brand -->
        <div class="footer-section">
          <h3 class="footer-brand">CLUTCH ARENA</h3>
          <p class="footer-description">
            A melhor plataforma de CS2 para jogadores competitivos.
          </p>
          <div class="footer-social">
            <v-icon class="social-icon" @click="openInstagram"
              >mdi-instagram</v-icon
            >
            <v-icon class="social-icon" @click="openDiscord">mdi-chat</v-icon>
            <v-icon class="social-icon" @click="openWhatsApp"
              >mdi-whatsapp</v-icon
            >
          </div>
        </div>

        <!-- Links Úteis -->
        <div class="footer-section">
          <h4 class="footer-section-title">Links Úteis</h4>
          <div class="footer-links">
            <a href="/rules" class="footer-link">Regras</a>

            <a href="/server-status" class="footer-link"
              >Status dos Servidores</a
            >
          </div>
        </div>

        <!-- Comunidade -->
        <div class="footer-section">
          <h4 class="footer-section-title">Comunidade</h4>
          <div class="footer-links">
            <a href="/discord" class="footer-link">Discord</a>
            <a href="/whatsapp" class="footer-link">WhatsApp</a>
            <a href="/tournaments" class="footer-link">Torneios</a>
            <a href="/ranking" class="footer-link">Leaderboards</a>
          </div>
        </div>

        <!-- Contato -->
        <div class="footer-section">
          <h4 class="footer-section-title">Contato</h4>
          <div class="footer-links">
            <a href="/support" class="footer-link">Suporte</a>
            <div class="footer-contact">
              <v-icon class="contact-icon">mdi-email</v-icon>
              <span>suporte@clutcharena.com.br</span>
            </div>
          </div>
        </div>
      </div>

      <div class="footer-divider"></div>

      <div class="footer-bottom">
        <p class="footer-copyright">
          &copy; 2025 Clutch Arena. Todos os direitos reservados.
        </p>
        <div class="footer-legal">
          <a href="/privacy" class="legal-link">Privacidade</a>
          <a href="/terms" class="legal-link">Termos</a>
          <a href="/cookies" class="legal-link">Cookies</a>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "Footer",
  methods: {
    openInstagram() {
      window.open("https://www.instagram.com/clutcharena.cs/", "_blank");
    },
    openDiscord() {
      window.open("https://www.clutcharena.com.br/discord", "_blank");
    },
    openWhatsApp() {
      window.open("https://www.clutcharena.com.br/whatsapp", "_blank");
    }
  }
};
</script>

<style scoped>
.footer {
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  background: #151619 !important;
}

.footer-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 32px 24px;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
}

@media (min-width: 768px) {
  .footer-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 32px;
  }
}

.footer-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.footer-brand {
  font-family: "Orbitron", system-ui, sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #ff711a;
  margin: 0;
}

.footer-description {
  color: #a3a3a3;
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
}

.footer-social {
  display: flex;
  gap: 16px;
}

.social-icon {
  color: #a3a3a3 !important;
  font-size: 20px !important;
  cursor: pointer;
  transition: color 300ms ease;
}

.social-icon:hover {
  color: #ff711a !important;
}

.footer-section-title {
  font-family: "Orbitron", system-ui, sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.footer-link {
  color: #a3a3a3;
  font-size: 14px;
  text-decoration: none;
  transition: color 300ms ease;
  line-height: 1.4;
}

.footer-link:hover {
  color: #ff711a;
}

.footer-contact {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #a3a3a3;
  font-size: 14px;
}

.contact-icon {
  color: #a3a3a3 !important;
  font-size: 16px !important;
}

.footer-support {
  color: #a3a3a3;
  font-size: 14px;
  margin: 0;
  line-height: 1.4;
}

.footer-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 32px 0;
}

.footer-bottom {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
}

@media (min-width: 600px) {
  .footer-bottom {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}

.footer-copyright {
  color: #a3a3a3;
  font-size: 14px;
  margin: 0;
}

.footer-legal {
  display: flex;
  gap: 24px;
}

.legal-link {
  color: #a3a3a3;
  font-size: 14px;
  text-decoration: none;
  transition: color 300ms ease;
}

.legal-link:hover {
  color: #ff711a;
}
</style>
